export enum Application {
  UptimeCenter = 'Husqvarna Uptime Center',
  Fleet = 'Husqvarna Fleet Services',
}